module.exports = __webpack_public_path__ + "static/media/christine-siracusa-vzX2rgUbQXM-unsplash.8125bd5b.jpg";